// AUTO-GENERATED product enrichment (galleries + spec tables) scraped from
// saunalife.com and leisurecraft.com. Merged into outdoorCatalogs.js.
// Regenerate via /tmp scrape scripts. Do not hand-edit.

export const ENRICHMENT = {
 "sl-e6": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2023/04/1-7-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-6-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-2-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/05/Ergo-Barrel-Cross-Section.jpg",
   "https://saunalife.com/wp-content/uploads/2023/05/Ergo-Sauna-Bench.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/vaade2-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Sauna-Bench-Closeup.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-5-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/vaade1-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "3 Persons"
   },
   {
    "label": "Weight",
    "value": "1202 lbs"
   },
   {
    "label": "Wood",
    "value": "Thermo-Aspen"
   }
  ]
 },
 "sl-e6w": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/1-8-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/2-4-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/05/Ergo-Barrel-Cross-Section.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Ergonomic-Sauna-Bench-Clsoeup.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/vaade2-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/vaade3-1-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/05/Ergo-Sauna-Bench.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/vaade1-1-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/09/saunalife-ee6g-barrel-sauna-interior.jpeg",
   "https://saunalife.com/wp-content/uploads/2023/08/Model-EE8G-Sauna-6.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/Model-X2.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "3 Persons"
   },
   {
    "label": "Dimensions",
    "value": "81\" Diameter & 59\" Length"
   },
   {
    "label": "Wall/Board Thickness",
    "value": "1.65\""
   },
   {
    "label": "Bench Depth",
    "value": "17.8\""
   },
   {
    "label": "Weight",
    "value": "1125 lbs"
   },
   {
    "label": "Wood",
    "value": "Thermo-Aspen"
   }
  ]
 },
 "sl-e7": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-6-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/1-7-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-2-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/05/Ergo-Barrel-Cross-Section.jpg",
   "https://saunalife.com/wp-content/uploads/2023/05/Ergo-Sauna-Bench.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/vaade2-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-5-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Sauna-Bench-Closeup.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/vaade1-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "4 Persons"
   },
   {
    "label": "Dimensions",
    "value": "81\" diameter & 71\" Length"
   },
   {
    "label": "Wall/Board Thickness",
    "value": "1.65\""
   },
   {
    "label": "Bench Depth",
    "value": "17.8\""
   },
   {
    "label": "Weight",
    "value": "1213 lbs"
   },
   {
    "label": "Wood",
    "value": "Thermo-Aspen"
   }
  ]
 },
 "sl-e7w": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/1-8-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/2-4-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/05/Ergo-Barrel-Cross-Section.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Ergonomic-Sauna-Bench-Clsoeup.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/vaade2-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/vaade1-1-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/05/Ergo-Sauna-Bench.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/vaade3-1-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-6-min.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "4 Persons"
   },
   {
    "label": "Dimensions",
    "value": "81\" Diameter & 71\" Length"
   },
   {
    "label": "Wall/Board Thickness",
    "value": "1.65\""
   },
   {
    "label": "Bench Depth",
    "value": "17.8\""
   },
   {
    "label": "Weight",
    "value": "1235 lbs"
   },
   {
    "label": "Wood",
    "value": "Thermo-Aspen"
   }
  ]
 },
 "sl-e7g": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2023/04/saunalife-barrel-sauna-min-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8G-Barrel-Sauna-3-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/ergo-g-sauna-barrel.jpg",
   "https://saunalife.com/wp-content/uploads/2023/05/Ergo-Barrel-Cross-Section.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Ergonomic-Sauna-bench-backrest.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/vaade2-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-5-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-6-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "4 Persons"
   },
   {
    "label": "Dimensions",
    "value": "81\" Diameter & 71\" Length"
   },
   {
    "label": "Wall/Board Thickness",
    "value": "1.65\""
   },
   {
    "label": "Bench Depth",
    "value": "17.8\""
   },
   {
    "label": "Weight",
    "value": "1279 lbs"
   },
   {
    "label": "Wood",
    "value": "Thermo-Aspen"
   }
  ]
 },
 "sl-e8": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-6-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/1-7-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-2-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/05/Ergo-Barrel-Cross-Section.jpg",
   "https://saunalife.com/wp-content/uploads/2023/05/Ergo-Sauna-Bench.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-4-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Sauna-Bench-Closeup.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-5-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/vaade1-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/2-3-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "6 Persons"
   },
   {
    "label": "Dimensions",
    "value": "81\" diameter & 87\" Length"
   },
   {
    "label": "Wall/Board Thickness",
    "value": "1.65\""
   },
   {
    "label": "Bench Depth",
    "value": "17.8\""
   },
   {
    "label": "Weight",
    "value": "1345 lbs"
   },
   {
    "label": "Wood",
    "value": "Thermo-Aspen"
   }
  ]
 },
 "sl-e8w": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/1-8-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/2-4-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/05/Ergo-Barrel-Cross-Section.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Ergonomic-Sauna-Bench-Clsoeup.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/vaade2-1-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/vaade3-1-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/05/Ergo-Sauna-Bench.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/vaade1-1-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-6-min.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "6 Persons"
   },
   {
    "label": "Dimensions",
    "value": "81\" diameter & 87\" Length"
   },
   {
    "label": "Wall/Board Thickness",
    "value": "1.65\""
   },
   {
    "label": "Bench Depth",
    "value": "17.8\""
   },
   {
    "label": "Weight",
    "value": "1367 lbs"
   },
   {
    "label": "Wood",
    "value": "Thermo-Aspen"
   }
  ]
 },
 "sl-e8g": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2023/04/saunalife-barrel-sauna-min-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8G-Barrel-Sauna-3-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/ergo-g-sauna-barrel.jpg",
   "https://saunalife.com/wp-content/uploads/2023/05/Ergo-Barrel-Cross-Section.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Ergonomic-Sauna-bench-backrest.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-4-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/05/Ergo-Sauna-LED-Bench.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/vaade3-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/vaade2-1-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/2-3-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E7G-2-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-6-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "6 Persons"
   },
   {
    "label": "Dimensions",
    "value": "81\" diameter & 87\" Length"
   },
   {
    "label": "Wall/Board Thickness",
    "value": "1.65\""
   },
   {
    "label": "Bench Depth",
    "value": "17.8\""
   },
   {
    "label": "Weight",
    "value": "1544 lbs"
   },
   {
    "label": "Wood",
    "value": "Thermo-Aspen"
   }
  ]
 },
 "sl-ee6g": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2023/09/saunalife-ee6g-barrel-sauna-interior.jpeg",
   "https://saunalife.com/wp-content/uploads/2023/09/saunalife-ee6g-barrel-sauna-1.jpg",
   "https://saunalife.com/wp-content/uploads/2023/09/saunalife-ee6g-barrel-sauna-3.jpg",
   "https://saunalife.com/wp-content/uploads/2023/09/saunalife-ee6g-barrel-sauna-2.jpg",
   "https://saunalife.com/wp-content/uploads/2023/09/saunalife-ee6g-barrel-sauna-cutaway.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-6-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "4 Persons"
   },
   {
    "label": "Dimensions",
    "value": "91\" Diameter & 63\" Length"
   },
   {
    "label": "Bench Depth",
    "value": "20.5\""
   },
   {
    "label": "Weight",
    "value": "1500 lbs"
   },
   {
    "label": "Wood",
    "value": "Thermo-Aspen"
   }
  ]
 },
 "sl-ee8g": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2023/08/Model-EE8G-Sauna-6.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/Model-EE8G-Sauna-1.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/Model-EE8G-Sauna-7.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/Model-EE8G-Sauna-3.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/Model-EE8G-Sauna-2.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/Model-EE8G-Sauna-Cutaway.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/Model-EE8G-Sauna-4.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/Model-EE8G-Sauna-5.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-6-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "6 Persons"
   },
   {
    "label": "Dimensions",
    "value": "91\" Diameter & 79\" Length"
   },
   {
    "label": "Bench Depth",
    "value": "19.8\""
   },
   {
    "label": "Weight",
    "value": "1763 lbs"
   },
   {
    "label": "Wood",
    "value": "Thermo-Aspen"
   }
  ]
 },
 "sl-x2": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2023/08/Model-X2.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/Model-X2-2.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/Model-X2-3.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/SaunaLife-X2-home-sauna-kit-1.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/SaunaLife-X2-sauna-kit-4.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/SaunaLife-Model-X2-sauna-kit-2.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/Model-X2-4.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-6-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "2 Persons"
   },
   {
    "label": "Weight",
    "value": "948 lbs"
   },
   {
    "label": "Wood",
    "value": "Nordic Spruce"
   }
  ]
 },
 "sl-g2": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2023/08/SaunaLife-Model-G2-Outdoor-Sauna.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/Model-G2-Floorplan.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/g2-outdoor-diy-sauna.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/SaunaLife-Model-G2-home-sauna.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/G2-backyard-home-sauna-cutaway.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/g2-sauna-interior-2.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/model-g2-sauna-interior-photo-1.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-6-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "4 Persons"
   },
   {
    "label": "Weight",
    "value": "1200 lbs"
   },
   {
    "label": "Wood",
    "value": "Nordic Spruce"
   }
  ]
 },
 "sl-g3": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2023/11/saunalife-model-g3-outdoor-home-sauna.jpg",
   "https://saunalife.com/wp-content/uploads/2023/11/saunalife-model-g3-home-sauna.jpg",
   "https://saunalife.com/wp-content/uploads/2023/11/saunalife-g3-outdoor-sauna-1.jpg",
   "https://saunalife.com/wp-content/uploads/2023/11/saunalife-model-g3-sauna.jpg",
   "https://saunalife.com/wp-content/uploads/2023/11/saunalife-model-g3-sauna-cutaway.jpg",
   "https://saunalife.com/wp-content/uploads/2023/11/model-g3-outdoor-sauna.jpg",
   "https://saunalife.com/wp-content/uploads/2023/11/model-g3-sauna.jpg",
   "https://saunalife.com/wp-content/uploads/2023/02/SaunaLife-G6-Outdoor-Sauna-05.jpg",
   "https://saunalife.com/wp-content/uploads/2024/03/SL-Model-G11-3.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "6 Persons"
   },
   {
    "label": "Weight",
    "value": "1900 lbs"
   },
   {
    "label": "Wood",
    "value": "Thermo-Spruce"
   }
  ]
 },
 "sl-g6": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2023/02/SaunaLife-G6-Outdoor-Sauna-05.jpg",
   "https://saunalife.com/wp-content/uploads/2023/02/SaunaLife-G6-Outdoor-Sauna-01.jpg",
   "https://saunalife.com/wp-content/uploads/2023/02/SaunaLife-G6-Outdoor-Sauna-02.jpg",
   "https://saunalife.com/wp-content/uploads/2023/02/SaunaLife-G6-Outdoor-Sauna-03.jpg",
   "https://saunalife.com/wp-content/uploads/2023/02/SaunaLife-G6-Outdoor-Sauna-04.jpg",
   "https://saunalife.com/wp-content/uploads/2023/02/SaunaLife-G6-Outdoor-Sauna-06.jpg",
   "https://saunalife.com/wp-content/uploads/2023/02/SaunaLife-G6-Outdoor-Sauna-07.jpg",
   "https://saunalife.com/wp-content/uploads/2023/02/SaunaLife-G6-Outdoor-Sauna-08.jpg",
   "https://saunalife.com/wp-content/uploads/2023/02/SaunaLife-G6-Outdoor-Sauna-09.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-6-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "5 Persons"
   },
   {
    "label": "Weight",
    "value": "2756 lbs"
   },
   {
    "label": "Wood",
    "value": "Thermo-Aspen"
   }
  ]
 },
 "sl-g11": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2023/08/saunalife-g11-outdoor-yard.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/SaunaLife-Model-G11-Cutaway.jpeg",
   "https://saunalife.com/wp-content/uploads/2024/03/SL-Model-G11-3.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/Model-G11-Sauna-Interior-1.jpg",
   "https://saunalife.com/wp-content/uploads/2023/08/Model-G11-Sauna-Interior-2.jpeg",
   "https://saunalife.com/wp-content/uploads/2023/08/Model-G11-Sauna-Exterior.jpeg",
   "https://saunalife.com/wp-content/uploads/2023/08/Model-G11-Sauna-Interior-4.jpeg",
   "https://saunalife.com/wp-content/uploads/2023/08/g11-interior.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-6-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "8 Persons"
   },
   {
    "label": "Weight",
    "value": "3196 lbs"
   },
   {
    "label": "Wood",
    "value": "Thermo-spruce"
   }
  ]
 },
 "sl-cl3g": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2025/04/saunalife-cl3g-cube-sauna-7b.jpg",
   "https://saunalife.com/wp-content/uploads/2025/05/SaunaLife-CL3G-R1.jpg",
   "https://saunalife.com/wp-content/uploads/2025/05/Model-CL3G-front-1.jpg",
   "https://saunalife.com/wp-content/uploads/2025/04/saunalife-cl3g-cube-sauna-4.jpg",
   "https://saunalife.com/wp-content/uploads/2025/05/saunalife-cl3g-cube-sauna-overhead.jpg",
   "https://saunalife.com/wp-content/uploads/2025/04/saunalife-cl3g-cube-sauna-5.jpg",
   "https://saunalife.com/wp-content/uploads/2025/05/Model-CL3G-Cube-Sauna-Side-1.jpg",
   "https://saunalife.com/wp-content/uploads/2025/04/saunalife-cl3g-cube-sauna-7.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-6-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "2 Persons"
   },
   {
    "label": "Weight",
    "value": "990 lbs"
   },
   {
    "label": "Wood",
    "value": "thermo-aspen"
   }
  ]
 },
 "sl-cl4g": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-Cube-CL4-Outdoor-Sauna.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-Cube-CL4-Outdoor-Sauna-2.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-CL4-Cube-Sauna-Kit-1.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-CL4-Cube-Sauna-Kit-2.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-CL4-Cube-Sauna-Kit-6.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-CL4-Cube-Sauna-Kit-5.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-CL4-Cube-Sauna-Kit-3.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-CL4-Cube-Sauna-Kit-4.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-6-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "3 Persons"
   },
   {
    "label": "Weight",
    "value": "1415 lbs"
   },
   {
    "label": "Wood",
    "value": "thermo-aspen"
   }
  ]
 },
 "sl-cl5g": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-CL5-Cube-Sauna-Kit-1a.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-CL5-Cube-Sauna-Kit-1b.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-CL5-Cube-Sauna-Kit-1.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-CL5-Cube-Sauna-Kit-2.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-CL5-Cube-Sauna-Kit-5a.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-CL5-Cube-Sauna-Kit-6.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/CL5G-sauna-5.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-CL5-Cube-Sauna-Kit-4.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-6-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "4 Persons"
   },
   {
    "label": "Weight",
    "value": "1680 lbs"
   },
   {
    "label": "Wood",
    "value": "thermo-aspen"
   }
  ]
 },
 "sl-cl7g": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-CL7-Cube-Sauna-Kit-1b.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-CL7-Cube-Sauna-Kit-1.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-CL7-Cube-Sauna-Kit-2.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-CL7-Cube-Sauna-Kit-6a.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-CL7-Cube-Sauna-Kit-5.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/saunalife-cube-sauna-cl7g-3.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/saunalife-cube-sauna-cl7g-4.jpg",
   "https://saunalife.com/wp-content/uploads/2024/06/SaunaLife-CL7-Cube-Sauna-Kit-6b.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-6-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "6 Persons"
   },
   {
    "label": "Weight",
    "value": "2040 lbs"
   },
   {
    "label": "Wood",
    "value": "thermo-aspen"
   }
  ]
 },
 "sl-cl12gcp": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2025/07/CL12GCP-2.jpg",
   "https://saunalife.com/wp-content/uploads/2025/07/CL12GCP-SaunaLife-Cube-Sauna-1.jpg",
   "https://saunalife.com/wp-content/uploads/2025/07/CL12GCP-SaunaLife-Cube-Sauna-2.jpg",
   "https://saunalife.com/wp-content/uploads/2025/07/CL12GCP-SaunaLife-Cube-Sauna-3.jpg",
   "https://saunalife.com/wp-content/uploads/2025/07/CL12GCP-SaunaLife-Cube-Sauna-4.jpg",
   "https://saunalife.com/wp-content/uploads/2025/07/CL12GCP-SaunaLife-Cube-Sauna-5.jpg",
   "https://saunalife.com/wp-content/uploads/2025/07/CL12GCP-SaunaLife-Cube-Sauna-6.jpg",
   "https://saunalife.com/wp-content/uploads/2025/07/CL12GCP-SaunaLife-Cube-Sauna-7.jpg",
   "https://saunalife.com/wp-content/uploads/2025/07/CL12GCP-SaunaLife-Cube-Sauna-8.jpg",
   "https://saunalife.com/wp-content/uploads/2025/07/CL12GCP-SaunaLife-Cube-Sauna-9.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-6-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "8 Persons"
   },
   {
    "label": "Weight",
    "value": "3450 lbs"
   },
   {
    "label": "Wood",
    "value": "Thermo-Aspen"
   }
  ]
 },
 "sl-gl4": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2025/09/saunalife-gl4-saune-kit-Hero-1.jpg",
   "https://saunalife.com/wp-content/uploads/2025/09/saunalife-gl4-sauna-kit-2.jpg",
   "https://saunalife.com/wp-content/uploads/2025/09/saunalife-gl4-sauna-kit-interior-2a.jpg",
   "https://saunalife.com/wp-content/uploads/2025/09/saunalife-gl4-sauna-kit-3.jpg",
   "https://saunalife.com/wp-content/uploads/2025/09/saunalife-gl4-sauna-kit-floorplan.jpg",
   "https://saunalife.com/wp-content/uploads/2025/09/saunalife-gl4-sauna-kit-interior-3b.jpg",
   "https://saunalife.com/wp-content/uploads/2025/09/saunalife-gl4-sauna-kit-interior.jpg",
   "https://saunalife.com/wp-content/uploads/2025/09/saunalife-gl4-sauna-kit-4.jpg",
   "https://saunalife.com/wp-content/uploads/2025/09/saunalife-gl4-sauna-kit-6.jpg",
   "https://saunalife.com/wp-content/uploads/2025/09/saunalife-gl4-sauna-kit-outdoor.jpg",
   "https://saunalife.com/wp-content/uploads/2025/09/saunalife-gl4-sauna-kit-1.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-6-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "4 Persons"
   },
   {
    "label": "Weight",
    "value": "1830 lbs"
   },
   {
    "label": "Wood",
    "value": "Thermo-Spruce"
   }
  ]
 },
 "sl-gl6": {
  "images": [
   "https://saunalife.com/wp-content/uploads/2025/09/SaunaLife-GL6-Sauna-Kit-R1.jpg",
   "https://saunalife.com/wp-content/uploads/2025/09/SaunaLife-GL6-Sauna-Kit-4.jpg",
   "https://saunalife.com/wp-content/uploads/2025/09/SaunaLife-GL6-Sauna-Kit-1.jpg",
   "https://saunalife.com/wp-content/uploads/2025/09/SaunaLife-GL6-Sauna-Kit-3.jpg",
   "https://saunalife.com/wp-content/uploads/2025/09/SaunaLife-GL6-Sauna-Kit-Outdoor-1.jpg",
   "https://saunalife.com/wp-content/uploads/2025/09/saunalife-gl6-sauna-kit-interior-1.jpg",
   "https://saunalife.com/wp-content/uploads/2025/09/SaunaLife-GL6-Sauna-Kit-R.jpg",
   "https://saunalife.com/wp-content/uploads/2025/09/saunalife-gl6-sauna-kit-back.jpg",
   "https://saunalife.com/wp-content/uploads/2025/09/saunalife-gl6-sauna-kit-floorplan.jpg",
   "https://saunalife.com/wp-content/uploads/2025/09/SaunaLife-GL6-Sauna-Kit-2.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/E8-Barrel-Sauna-6-min.jpg",
   "https://saunalife.com/wp-content/uploads/2023/04/Half-moon-glass-min.jpg"
  ],
  "specs": [
   {
    "label": "Capacity",
    "value": "6 Persons"
   },
   {
    "label": "Weight",
    "value": "2425 lbs"
   },
   {
    "label": "Wood",
    "value": "thermo-spruce"
   }
  ]
 },
 "lc-sunlight-shower": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/512SN_0JGNS5V3T0PBSGP0/512SN_10.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/512SN_0JGNS5V3T0PBSGP0/512SN_11.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/512SN_0JGNS5V3T0PBSGP0/512SN_20.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/512SN_0JGNS5V3T0PBSGP0/512SN_21.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/512SN_0JGNS5V3T0PBSGP0/512SN_50.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/512SN_0JGNS5V3T0PBSGP0/512SN_51.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/512SN_0JGNS5V3T0PBSGP0/512SN_52.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/512SN_0JGNS5V3T0PBSGP0/512SN_53.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/512SN_0JGNS5V3T0PBSGP0/512SN_54.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/512SN_0JGNS5V3T0PBSGP0/512SN_55.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/512SN_0JGNS5V3T0PBSGP0/512SN_56.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/512SN_0JGNS5V3T0PBSGP0/512SN_80.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/512SN_0JGNS5V3T0PBSGP0/512SN_81.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/512SN_0JGNS5V3T0PBSGP0/512SN_82.jpg"
  ],
  "specs": [
   {
    "label": "Boxed & Skidded",
    "value": "55"
   },
   {
    "label": "Base Depth",
    "value": "31″"
   },
   {
    "label": "Base Width",
    "value": "31″"
   },
   {
    "label": "Base Height",
    "value": "3.25″"
   },
   {
    "label": "Pillar Depth",
    "value": "5.5″"
   },
   {
    "label": "Pillar Width",
    "value": "13″"
   },
   {
    "label": "Pillar Height",
    "value": "78.25″"
   },
   {
    "label": "Total Height",
    "value": "81.5″"
   }
  ]
 },
 "lc-ct-sierra-shower": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC105_6PITP1IAS0PBSGP0/CTC105N_10.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC105_6PITP1IAS0PBSGP0/CTC105N_11.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC105_6PITP1IAS0PBSGP0/CTC105N_16.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC105_6PITP1IAS0PBSGP0/CTC105N_20.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC105_6PITP1IAS0PBSGP0/CTC105N_21.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC105_6PITP1IAS0PBSGP0/CTC105N_30.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC105_6PITP1IAS0PBSGP0/CTC105N_40.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC105_6PITP1IAS0PBSGP0/CTC105N_41.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC105_6PITP1IAS0PBSGP0/CTC105N_42.jpg"
  ],
  "specs": [
   {
    "label": "Boxed & Skidded",
    "value": "49"
   },
   {
    "label": "Base Depth",
    "value": "31″"
   },
   {
    "label": "Base Width",
    "value": "31″"
   },
   {
    "label": "Base Height",
    "value": "3.25″"
   }
  ]
 },
 "lc-cloudburst-shower": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/552SN_E7136FO4T0PBSGP0/552SN_21.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/552SN_E7136FO4T0PBSGP0/_10.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/552SN_E7136FO4T0PBSGP0/_20.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/552SN_E7136FO4T0PBSGP0/_40.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/552SN_E7136FO4T0PBSGP0/_50.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/552SN_E7136FO4T0PBSGP0/_51.jpg"
  ],
  "specs": [
   {
    "label": "Shower Crate",
    "value": "360"
   },
   {
    "label": "Width",
    "value": "40″"
   },
   {
    "label": "Depth",
    "value": "40″"
   },
   {
    "label": "Height",
    "value": "83.25″"
   }
  ]
 },
 "lc-skylight-combo": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/8484GW_K6FVEQ12KGAT9N31/8484GW_1.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/8484GW_K6FVEQ12KGAT9N31/8484GW_10.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/8484GW_K6FVEQ12KGAT9N31/8484GW_11.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/8484GW_K6FVEQ12KGAT9N31/8484GW_12.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/8484GW_K6FVEQ12KGAT9N31/8484GW_2.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/8484GW_K6FVEQ12KGAT9N31/8484GW_3.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/8484GW_K6FVEQ12KGAT9N31/8484GW_4.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/8484GW_K6FVEQ12KGAT9N31/8484GW_5.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/8484GW_K6FVEQ12KGAT9N31/8484GW_6.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/8484GW_K6FVEQ12KGAT9N31/8484GW_7.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/8484GW_K6FVEQ12KGAT9N31/8484GW_8.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/8484GW_K6FVEQ12KGAT9N31/8484GW_9.jpg"
  ],
  "specs": [
   {
    "label": "Comfortably Seats",
    "value": "4 People"
   },
   {
    "label": "Exterior Depth",
    "value": "71″"
   },
   {
    "label": "Exterior Width",
    "value": "84″"
   },
   {
    "label": "Exterior Height",
    "value": "84″"
   },
   {
    "label": "Interior Depth",
    "value": "63.5″"
   },
   {
    "label": "Interior Width",
    "value": "80.75″"
   },
   {
    "label": "Interior Height",
    "value": "80.75″"
   },
   {
    "label": "Interior Volume",
    "value": "193 ft³"
   },
   {
    "label": "Wood Heater Available",
    "value": "Yes ✔"
   },
   {
    "label": "Electric Heater Available",
    "value": "Yes ✔"
   },
   {
    "label": "Recommended Electric Heater Size",
    "value": "4.5 - 6 KW"
   },
   {
    "label": "Sauna Crate",
    "value": "707"
   }
  ]
 },
 "lc-ct-savannah-shower": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC205_QSFT27VAS0PBSGP0/CTC205N_10.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC205_QSFT27VAS0PBSGP0/CTC205N_11.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC205_QSFT27VAS0PBSGP0/CTC205N_18.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC205_QSFT27VAS0PBSGP0/CTC205N_20.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC205_QSFT27VAS0PBSGP0/CTC205N_30.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC205_QSFT27VAS0PBSGP0/CTC205N_40.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC205_QSFT27VAS0PBSGP0/CTC205N_41.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC205_QSFT27VAS0PBSGP0/CTC205N_42.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC205_QSFT27VAS0PBSGP0/CTC205N_90.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC205_QSFT27VAS0PBSGP0/CTC205N_91.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC205_QSFT27VAS0PBSGP0/CTC205N_92.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC205_QSFT27VAS0PBSGP0/CTC205N_93.jpg"
  ],
  "specs": [
   {
    "label": "Boxed & Skidded",
    "value": "107"
   },
   {
    "label": "Base Depth",
    "value": "31″"
   },
   {
    "label": "Base Width",
    "value": "31″"
   },
   {
    "label": "Base Height",
    "value": "3.25″"
   }
  ]
 },
 "lc-rainbow-shower": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/582SN_QV9IMJM5T0PBSGP0/582SN_10.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/582SN_QV9IMJM5T0PBSGP0/582SN_11.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/582SN_QV9IMJM5T0PBSGP0/582SN_12.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/582SN_QV9IMJM5T0PBSGP0/582SN_13.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/582SN_QV9IMJM5T0PBSGP0/582SN_20.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/582SN_QV9IMJM5T0PBSGP0/582SN_21.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/582SN_QV9IMJM5T0PBSGP0/582SN_30.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/582SN_QV9IMJM5T0PBSGP0/582SN_40.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/582SN_QV9IMJM5T0PBSGP0/582SN_41.jpg"
  ],
  "specs": [
   {
    "label": "Diameter",
    "value": "60″"
   },
   {
    "label": "Height",
    "value": "80″"
   },
   {
    "label": "Shower Crate",
    "value": "511"
   }
  ]
 },
 "lc-southern-tiki": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT3672N_6PEJ4DIMN0PBSGP0/CT3672N_10.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT3672N_6PEJ4DIMN0PBSGP0/CT3672N_11.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT3672N_6PEJ4DIMN0PBSGP0/CT3672N_12.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT3672N_6PEJ4DIMN0PBSGP0/CT3672N_13.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT3672N_6PEJ4DIMN0PBSGP0/CT3672N_20.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT3672N_6PEJ4DIMN0PBSGP0/CT3672N_21.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT3672N_6PEJ4DIMN0PBSGP0/CT3672N_22.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT3672N_6PEJ4DIMN0PBSGP0/CT3672N_50.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT3672N_6PEJ4DIMN0PBSGP0/CT3672N_51.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT3672N_6PEJ4DIMN0PBSGP0/CT3672N_52.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT3672N_6PEJ4DIMN0PBSGP0/CT3672N_60.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT3672N_6PEJ4DIMN0PBSGP0/CT3672N_61.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT3672N_6PEJ4DIMN0PBSGP0/CT3672N_80.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT3672N_6PEJ4DIMN0PBSGP0/CT3672N_81.jpg"
  ],
  "specs": [
   {
    "label": "Comfortably Seats",
    "value": "4 - 5"
   },
   {
    "label": "Base Depth",
    "value": "30.5″"
   },
   {
    "label": "Base Width",
    "value": "60″"
   },
   {
    "label": "Base Height",
    "value": "42.5″"
   }
  ]
 },
 "lc-tropical-tiki": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT4896N_8GV5JBKNN0PBSGP0/CT4896N_10.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT4896N_8GV5JBKNN0PBSGP0/CT4896N_11.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT4896N_8GV5JBKNN0PBSGP0/CT4896N_20.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT4896N_8GV5JBKNN0PBSGP0/CT4896N_21.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT4896N_8GV5JBKNN0PBSGP0/CT4896N_22.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT4896N_8GV5JBKNN0PBSGP0/CT4896N_30.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT4896N_8GV5JBKNN0PBSGP0/CT4896N_31.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT4896N_8GV5JBKNN0PBSGP0/CT4896N_50.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT4896N_8GV5JBKNN0PBSGP0/CT4896N_51.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT4896N_8GV5JBKNN0PBSGP0/CT4896N_60.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT4896N_8GV5JBKNN0PBSGP0/CT4896N_61.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT4896N_8GV5JBKNN0PBSGP0/CT4896N_62.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT4896N_8GV5JBKNN0PBSGP0/CT4896N_80.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT4896N_8GV5JBKNN0PBSGP0/CT4896N_81.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT4896N_8GV5JBKNN0PBSGP0/CT4896N_82.jpg"
  ],
  "specs": [
   {
    "label": "Comfortably Seats",
    "value": "4 - 5"
   },
   {
    "label": "Base Depth",
    "value": "30.5″"
   },
   {
    "label": "Base Width",
    "value": "60″"
   },
   {
    "label": "Base Height",
    "value": "42.5″"
   }
  ]
 },
 "lc-outdoor-kitchen": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L566N_7GRK354QO0PBSGP0/kitchen-small.jpg"
  ]
 },
 "lc-log-captains-stool": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L144N_12G63SFLO0PBSGP0/L144N_1.jpg"
  ]
 },
 "lc-saddle-stool": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT1460N_198H7UKNM0PBSGP0/stool-saddle.jpg"
  ]
 },
 "lc-stool-back": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT1420N_FD6OBDLMM0PBSGP0/stool-back.jpg"
  ]
 },
 "lc-adirondack-chair": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L214N_AEIGU1VGO0PBSGP0/L214N_1.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L214N_AEIGU1VGO0PBSGP0/L214N_2.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L214N_AEIGU1VGO0PBSGP0/L214N_3.jpg"
  ]
 },
 "lc-adirondack-kids": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L205N_E1NPUUAGO0PBSGP0/L205N_1.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L205N_E1NPUUAGO0PBSGP0/L205N_2.jpg"
  ]
 },
 "lc-pacific-chair": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/PM110_I465N7AJO0PBSGP0/PM110N_1.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/PM110_I465N7AJO0PBSGP0/PM110N_2.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/PM110_I465N7AJO0PBSGP0/PM110N_3.jpg"
  ]
 },
 "lc-adirondack-footrest": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/70112018N_MGESEPGBO0PBSGP0/70112018N_1.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/70112018N_MGESEPGBO0PBSGP0/_81.jpg"
  ]
 },
 "lc-2seat-bench": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L224_87NPE0LGO0PBSGP0/L224N_1.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L224_87NPE0LGO0PBSGP0/L224N_2.jpg"
  ]
 },
 "lc-gossip-bench": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L234N_GBKMO8MHO0PBSGP0/L234N_1.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L234N_GBKMO8MHO0PBSGP0/L234N_2.jpg"
  ]
 },
 "lc-curved-bench": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L525N_BVSNJ3QPO0PBSGP0/L525N_1.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L525N_BVSNJ3QPO0PBSGP0/L525N_2.jpg"
  ]
 },
 "lc-log-dining-bench": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L520N_DCI8CLD1P0PBSGP0/L520N_1.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L520N_DCI8CLD1P0PBSGP0/L520N_2.jpg"
  ]
 },
 "lc-picnic-table": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L415N_FLCTJTPLO0PBSGP0/_10.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L415N_FLCTJTPLO0PBSGP0/_11.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L415N_FLCTJTPLO0PBSGP0/_20.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L415N_FLCTJTPLO0PBSGP0/_21.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L415N_FLCTJTPLO0PBSGP0/_22.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L415N_FLCTJTPLO0PBSGP0/_80.jpg"
  ]
 },
 "lc-log-dining-table": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L510N_PCF56S42P0PBSGP0/L510N_1.jpg"
  ]
 },
 "lc-bistro-table": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L124N_9OES8HCKO0PBSGP0/L124N_1.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L124N_9OES8HCKO0PBSGP0/L124N_2.jpg"
  ]
 },
 "lc-round-coffee": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L102N_I3P3VRUCO0PBSGP0/L102N_1.jpg"
  ]
 },
 "lc-oval-coffee": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L138N_AN2IET0GO0PBSGP0/L138N_1.jpg"
  ]
 },
 "lc-square-end": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L135N_2MGLAEKFO0PBSGP0/L135N_1.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L135N_2MGLAEKFO0PBSGP0/L135N_2.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L135N_2MGLAEKFO0PBSGP0/L135N_3.jpg"
  ]
 },
 "lc-adirondack-foldable-end": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/70102023_42925FVAO0PBSGP0/_10.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/70102023_42925FVAO0PBSGP0/_11.jpg"
  ]
 },
 "lc-adirondack-square": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/70122018_OCLF4G3CO0PBSGP0/70122018N_1.jpg"
  ]
 },
 "lc-pacific-coffee": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/PM108N_MHGOU4VIO0PBSGP0/PM108N_1.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/PM108N_MHGOU4VIO0PBSGP0/PM108N_2.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/PM108N_MHGOU4VIO0PBSGP0/PM108N_3.jpg"
  ]
 },
 "lc-table-stool": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L136_OBD7P76FO0PBSGP0/L136N_1.jpg"
  ]
 },
 "ht-huum-drop": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/HUUMDROP_GK7EK1L18IAT9N31/_10.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/HUUMDROP_GK7EK1L18IAT9N31/_14.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/HUUMDROP_GK7EK1L18IAT9N31/_20.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/HUUMDROP_GK7EK1L18IAT9N31/_22.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/HUUMDROP_GK7EK1L18IAT9N31/_24.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/HUUMDROP_GK7EK1L18IAT9N31/_26.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/HUUMDROP_GK7EK1L18IAT9N31/_30.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/HUUMDROP_GK7EK1L18IAT9N31/_60.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/HUUMDROP_GK7EK1L18IAT9N31/_70.jpg"
  ]
 },
 "ht-huum-hive-mini": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/HUUMHIVE_TDO260CF8IAT9N31/HUUMHIVE_1.jpg"
  ]
 },
 "ht-homecraft-revive": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REV240_86VT8K7M9JAT9N31/_10.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REV240_86VT8K7M9JAT9N31/_11.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REV240_86VT8K7M9JAT9N31/_12.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REV240_86VT8K7M9JAT9N31/_15.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REV240_86VT8K7M9JAT9N31/_16.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REV240_86VT8K7M9JAT9N31/_20.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REV240_86VT8K7M9JAT9N31/_24.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REV240_86VT8K7M9JAT9N31/_30.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REV240_86VT8K7M9JAT9N31/_50.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REV240_86VT8K7M9JAT9N31/_91.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REV240_86VT8K7M9JAT9N31/_93.jpg"
  ]
 },
 "ht-homecraft-revive-slim": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REVSLI_N8SENROJBJAT9N31/_14.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REVSLI_N8SENROJBJAT9N31/_16.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REVSLI_N8SENROJBJAT9N31/_18.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REVSLI_N8SENROJBJAT9N31/_19.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REVSLI_N8SENROJBJAT9N31/_20.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REVSLI_N8SENROJBJAT9N31/_24.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REVSLI_N8SENROJBJAT9N31/_26.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REVSLI_N8SENROJBJAT9N31/_91.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REVSLI_N8SENROJBJAT9N31/_92.jpg"
  ]
 },
 "ht-homecraft-apex": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/APEX240_RPDQIMDR7JAT9N31/_12.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/APEX240_RPDQIMDR7JAT9N31/_14.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/APEX240_RPDQIMDR7JAT9N31/_20.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/APEX240_RPDQIMDR7JAT9N31/_22.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/APEX240_RPDQIMDR7JAT9N31/_24.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/APEX240_RPDQIMDR7JAT9N31/_26.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/APEX240_RPDQIMDR7JAT9N31/_28.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/APEX240_RPDQIMDR7JAT9N31/_34.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/APEX240_RPDQIMDR7JAT9N31/_80.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/APEX240_RPDQIMDR7JAT9N31/_90.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/APEX240_RPDQIMDR7JAT9N31/_91.jpg"
  ]
 },
 "ht-homecraft-apex-mini": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/APMI240_1VNL30UJ3KAT9N31/apex-mini_1.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/APMI240_1VNL30UJ3KAT9N31/apex-mini_2.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/APMI240_1VNL30UJ3KAT9N31/apex-mini_3.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/APMI240_1VNL30UJ3KAT9N31/apex-mini_4.jpg"
  ]
 },
 "ht-harvia-kip": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/HARVKIP_5N7K4M06SJAT9N31/HARKIPN_1.jpg"
  ]
 },
 "ht-timberglow14": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/120224_56FBGC689IAT9N31/120224_1.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/120224_56FBGC689IAT9N31/120224_2.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/120224_56FBGC689IAT9N31/120224_3.jpg"
  ],
  "specs": [
   {
    "label": "Sauna Room Size",
    "value": "250-600 ft⊃ (7-17 m³)"
   },
   {
    "label": "Width",
    "value": "20″"
   },
   {
    "label": "Depth",
    "value": "24″"
   },
   {
    "label": "Height",
    "value": "36″"
   },
   {
    "label": "Weight without Rocks",
    "value": "100 lbs"
   },
   {
    "label": "Rock Capacity",
    "value": "200 lbs"
   },
   {
    "label": "Weight with Rocks",
    "value": "300 lbs"
   },
   {
    "label": "Minimum Side Clearance",
    "value": "6″"
   },
   {
    "label": "Minimum Front Clearance",
    "value": "36″"
   },
   {
    "label": "Minimum Top Clearance",
    "value": "44″"
   },
   {
    "label": "Minimum Back Clearance",
    "value": "10″"
   },
   {
    "label": "Mounting Type",
    "value": "Floor-Standing"
   }
  ]
 },
 "ht-narvi-kaamos": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARKAAM_1UGTV6SLAIAT9N31/_12.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARKAAM_1UGTV6SLAIAT9N31/_90.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARKAAM_1UGTV6SLAIAT9N31/_91.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARKAAM_1UGTV6SLAIAT9N31/_92.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARKAAM_1UGTV6SLAIAT9N31/_93.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARKAAM_1UGTV6SLAIAT9N31/_95.jpg"
  ],
  "specs": [
   {
    "label": "Sauna Room Size",
    "value": "8-16 m³"
   },
   {
    "label": "Width",
    "value": "15.7″"
   },
   {
    "label": "Depth",
    "value": "20.1″"
   },
   {
    "label": "Height",
    "value": "29.9″"
   },
   {
    "label": "Adjustment Range",
    "value": "0.6″"
   },
   {
    "label": "Weight without Rocks",
    "value": "125.7 lbs"
   },
   {
    "label": "Rock Capacity",
    "value": "110.2 lbs"
   },
   {
    "label": "Weight with Rocks",
    "value": "235.9 lbs"
   },
   {
    "label": "Minimum Side Clearance",
    "value": "11.8″"
   },
   {
    "label": "Minimum Front Clearance",
    "value": "19.7″"
   },
   {
    "label": "Minimum Top Clearance",
    "value": "50″"
   },
   {
    "label": "Minimum Back Clearance",
    "value": "7.9″"
   }
  ]
 },
 "ht-narvi-kuru": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARKURU_FCDK6V0A8IAT9N31/_14.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARKURU_FCDK6V0A8IAT9N31/_20.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARKURU_FCDK6V0A8IAT9N31/_21.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARKURU_FCDK6V0A8IAT9N31/_90.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARKURU_FCDK6V0A8IAT9N31/_91.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARKURU_FCDK6V0A8IAT9N31/_92.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARKURU_FCDK6V0A8IAT9N31/_93.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARKURU_FCDK6V0A8IAT9N31/_94.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARKURU_FCDK6V0A8IAT9N31/_95.jpg"
  ],
  "specs": [
   {
    "label": "Sauna Room Size",
    "value": "8-14 m³"
   },
   {
    "label": "Width",
    "value": "16.5″"
   },
   {
    "label": "Depth",
    "value": "18.7″"
   },
   {
    "label": "Height",
    "value": "26.6″"
   },
   {
    "label": "Adjustment Range",
    "value": "0.6″"
   },
   {
    "label": "Weight without Rocks",
    "value": "108 lbs"
   },
   {
    "label": "Rock Capacity",
    "value": "77.2 lbs"
   },
   {
    "label": "Weight with Rocks",
    "value": "185.2 lbs"
   },
   {
    "label": "Minimum Side Clearance",
    "value": "9.8″"
   },
   {
    "label": "Minimum Front Clearance",
    "value": "19.7″"
   },
   {
    "label": "Minimum Top Clearance",
    "value": "53.1″"
   },
   {
    "label": "Minimum Back Clearance",
    "value": "9.8″"
   }
  ]
 },
 "ht-narvi-nc-black": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARVINC_JBAU2N9O6IAT9N31/_10.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARVINC_JBAU2N9O6IAT9N31/_18.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARVINC_JBAU2N9O6IAT9N31/_20.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARVINC_JBAU2N9O6IAT9N31/_22.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARVINC_JBAU2N9O6IAT9N31/_24.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARVINC_JBAU2N9O6IAT9N31/_90.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARVINC_JBAU2N9O6IAT9N31/_91.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARVINC_JBAU2N9O6IAT9N31/_92.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARVINC_JBAU2N9O6IAT9N31/_93.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARVINC_JBAU2N9O6IAT9N31/_94.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARVINC_JBAU2N9O6IAT9N31/_95.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARVINC_JBAU2N9O6IAT9N31/_96.jpg"
  ],
  "specs": [
   {
    "label": "Sauna Room Size",
    "value": "8-16 m³"
   },
   {
    "label": "Width",
    "value": "19.7″"
   },
   {
    "label": "Depth",
    "value": "22.8″"
   },
   {
    "label": "Height",
    "value": "30.7″"
   },
   {
    "label": "Adjustment Range",
    "value": "0.6″"
   },
   {
    "label": "Weight without Rocks",
    "value": "158.7 lbs"
   },
   {
    "label": "Rock Capacity",
    "value": "110.2 lbs"
   },
   {
    "label": "Weight with Rocks",
    "value": "268.9 lbs"
   },
   {
    "label": "Minimum Side Clearance",
    "value": "5.9″"
   },
   {
    "label": "Minimum Front Clearance",
    "value": "19.7″"
   },
   {
    "label": "Minimum Top Clearance",
    "value": "49.2″"
   },
   {
    "label": "Minimum Back Clearance",
    "value": "5.9″"
   }
  ]
 },
 "ht-narvi-velvet": {
  "images": [
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARVELV_DPD8GAFT3KAT9N31/Narvi-velvet_3.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARVELV_DPD8GAFT3KAT9N31/narvi-velvet_1.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARVELV_DPD8GAFT3KAT9N31/narvi-velvet_2.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARVELV_DPD8GAFT3KAT9N31/narvi-velvet_4.jpg",
   "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARVELV_DPD8GAFT3KAT9N31/narvi-velvet_6.jpg"
  ],
  "specs": [
   {
    "label": "Sauna Room Size",
    "value": "8-20 m³"
   },
   {
    "label": "Width",
    "value": "21.3″"
   },
   {
    "label": "Depth",
    "value": "22.8″"
   },
   {
    "label": "Height",
    "value": "30.7″"
   },
   {
    "label": "Adjustment Range",
    "value": "0.6″"
   },
   {
    "label": "Weight without Rocks",
    "value": "196 lbs"
   },
   {
    "label": "Rock Capacity",
    "value": "221 lbs"
   },
   {
    "label": "Weight with Rocks",
    "value": "417 lbs"
   },
   {
    "label": "Minimum Side Clearance",
    "value": "5.9″"
   },
   {
    "label": "Minimum Front Clearance",
    "value": "19.7″"
   },
   {
    "label": "Minimum Top Clearance",
    "value": "48″"
   },
   {
    "label": "Minimum Back Clearance",
    "value": "7.9″"
   }
  ]
 }
};
